import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import Company from '@/App/Company/Entity/Company'
import Customer from '@/App/Customer/Entity/Customer'
import LocalizerService from '@/Shared/Service/Localization/LocalizerService'
import type {
    LocaleEnum,
    LocaleEnumDataEntry,
} from '@/Shared/AutoGenerated/LocalizationEnum'
import type { BookingFormSharedDataRawData } from '@/Shared/AutoGenerated/Main'

// --------------
// TODO: This must be in sync with other pages defining "BookingFormLayoutProps" interface :(
// --------------
interface BookingFormLayoutProps {
    appName: string
    isFreePlan: boolean
    bookingFormCompany: Company
    authCustomer: Customer | null
    errorMessage: string | null
    googleSocialLoginEnabled: boolean
    currentUrl: string
    currentLocale: LocaleEnum
    currentLocaleEnumData: LocaleEnumDataEntry
    openCookieSettingsElementId: string

    // FE only
    containerClasses: string
    showCoverImage: boolean
}

export default class BookingFormSharedData {
    public containerClasses = 'max-w-5xl'
    public showCoverImage = true

    constructor(
        public readonly appName: string,
        public readonly isFreePlan: boolean,
        public readonly bookingFormCompany: Company,
        public readonly authCustomer: Customer | null,
        public readonly googleSocialLoginEnabled: boolean,
        public readonly currentUrl: string,
        public readonly flashErrorMessage: string | null,
        public readonly currentLocale: LocaleEnum,
        public readonly openCookieSettingsElementId: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrate(
        rawData: BookingFormSharedDataRawData,
    ): BookingFormSharedData {
        return new BookingFormSharedData(
            rawData.appName,
            rawData.isFreePlan,
            Company.hydrateSingle(rawData.bookingFormCompany),
            Customer.hydrateSingleOrNull(rawData.authCustomer),
            rawData.googleSocialLoginEnabled,
            rawData.currentUrl,
            rawData.flashErrorMessage,
            rawData.currentLocale,
            rawData.openCookieSettingsElementId,
        )
    }

    setContainerClasses(containerClasses: string): BookingFormSharedData {
        this.containerClasses = containerClasses

        return this
    }

    setCoverImageHidden(): BookingFormSharedData {
        this.showCoverImage = false

        return this
    }

    getBookingFormLayoutProps(): BookingFormLayoutProps {
        return {
            appName: this.appName,
            isFreePlan: this.isFreePlan,
            bookingFormCompany: this.bookingFormCompany,
            authCustomer: this.authCustomer,
            errorMessage: this.flashErrorMessage,
            googleSocialLoginEnabled: this.googleSocialLoginEnabled,
            currentUrl: this.currentUrl,
            containerClasses: this.containerClasses,
            showCoverImage: this.showCoverImage,
            currentLocale: this.currentLocale,
            currentLocaleEnumData: LocalizerService.make(this.currentLocale)
                .enumData,
            openCookieSettingsElementId: this.openCookieSettingsElementId,
        }
    }
}
